<div class="container my-5 d-flex flex-column justify-content-center">

    <div class="btn-white me-auto mb-3" (click)="goBack()">
        Back
    </div>
    <div class="table-wrapper p-4" style="border-radius: 10px;">


        @if(!errorLoadingDetails){@if(details){
        <!-- ASSESSMENT -->
        @if(!searchedDataNotFound){
        <div *ngIf="qrCodeType.toLocaleUpperCase() == 'ASSESSMENT'" class="wrapper">
            <h4 class="title mb-3">IGR ASSESSMENT DETAILS</h4>
            <dl class="datalist">
                <div class="datalist-item">
                    <dt>Taxpayer Name</dt>
                    <dd>{{ details.displayName }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Filing Date</dt>
                    <dd>{{ details.filingDate }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Assessment Date</dt>
                    <dd>{{ details.assessmentDate }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Filing Year</dt>
                    <dd>{{ details.filingYear }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Assessment Year</dt>
                    <dd>{{ details.assessmentYear }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Gross Income</dt>
                    <dd>{{ details.grossIncome | nairaCurrency }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>ASIN</dt>
                    <dd>{{ details.asin }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Assessment ID</dt>
                    <dd>{{ details.assessmentId }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Approval Status</dt>
                    <dd [ngClass]="'status-text-' + (details.approvalStatus | lowercase)">{{ details.approvalStatus }}
                    </dd>
                </div>
                <div class="datalist-item">
                    <dt>Payment Status</dt>
                    <dd [ngClass]="'status-text-' + (details.paymentStatus | lowercase)">{{ details.paymentStatus }}
                    </dd>
                </div>
                <div class="datalist-item">
                    <dt>Assessed By</dt>
                    <dd>{{ details.assessedBy }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Phone Number</dt>
                    <dd>{{ details.phoneNumber }}</dd>
                </div>
            </dl>
        </div>
        <!-- LGA_IDENTIFICATION -->
        <div *ngIf="qrCodeType.toUpperCase() == 'LGA_IDENTIFICATION'" class="wrapper">
            <h4 class="title mb-3">LGA IDENTIFICATION DETAILS</h4>
            <dl class="datalist">
                <div class="datalist-item">
                    <dt>Full Name</dt>
                    <dd>{{ details.displayName }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Application ID</dt>
                    <dd>{{ details.applicationId }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Approval Date</dt>
                    <dd>{{ details.approvalDate }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Approved By</dt>
                    <dd>{{ details.approvedBy }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Approval Status</dt>
                    <dd [ngClass]="'status-text-' + (details.approvalStatus | lowercase)">{{ details.approvalStatus }}
                    </dd>
                </div>
                <div class="datalist-item">
                    <dt>Payment Status</dt>
                    <dd [ngClass]="'status-text-' + (details.paymentStatus | lowercase)">{{ details.paymentStatus }}
                    </dd>
                </div>
                <div class="datalist-item">
                    <dt>Amount</dt>
                    <dd>{{ details.amount | nairaCurrency }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Purpose</dt>
                    <dd>{{ details.certificatePurpose }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Age</dt>
                    <dd>{{ details.age }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Phone Number</dt>
                    <dd>{{ details.phoneNumber }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Email</dt>
                    <dd>{{ details.email }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Street</dt>
                    <dd>{{ details.street }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Compound Name</dt>
                    <dd>{{ details.compoundName }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Ward</dt>
                    <dd>{{ details.ward }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Approval Document</dt>
                    <dd>
                        <a [href]="details.approvalUrl" target="_blank">View Document</a>
                    </dd>
                </div>
            </dl>
        </div>


        <!-- Marriage Reg -->
<div *ngIf="qrCodeType.toUpperCase() === 'MARRIAGE_REGISTRATION'" class="wrapper">
  <h4 class="title mb-3">MARRIAGE REGISTRATION DETAILS</h4>

  <dl class="datalist">
    <div class="datalist-item">
      <dt>Application ID</dt>
      <dd>{{ details.applicationId }}</dd>
    </div>

    <div class="datalist-item">
      <dt>Approval Status</dt>
      <dd [ngClass]="'status-text-' + (details.approvalStatus | lowercase)">
        {{ details.approvalStatus }}
      </dd>
    </div>

    <div class="datalist-item">
      <dt>Payment Status</dt>
      <dd [ngClass]="'status-text-' + (details.paymentStatus | lowercase)">
        {{ details.paymentStatus }}
      </dd>
    </div>

    <div class="datalist-item">
      <dt>Status</dt>
      <dd [ngClass]="'status-text-' + (details.status | lowercase)">
        {{ details.status }}
      </dd>
    </div>

    <div class="datalist-item">
      <dt>Amount</dt>
      <dd>{{ details.amount | nairaCurrency }}</dd>
    </div>

    <!-- Groom Details -->
    <h5 class="mt-3">GROOM DETAILS</h5>
    <div class="datalist-item">
      <dt>Full Name</dt>
      <dd>{{ details.bachelor.firstName }} {{ details.bachelor.lastName }}</dd>
    </div>
    <div class="datalist-item">
      <dt>Date of Birth</dt>
      <dd>{{ details.bachelor.dob }}</dd>
    </div>
    <div class="datalist-item">
      <dt>Phone</dt>
      <dd>{{ details.bachelor.phoneNumber }}</dd>
    </div>
    <div class="datalist-item">
      <dt>Address</dt>
      <dd>{{ details.bachelor.address }}</dd>
    </div>
    <div class="datalist-item">
      <dt>State / LGA</dt>
      <dd>{{ details.bachelor.state }} / {{ details.bachelor.lga }}</dd>
    </div>
    <div class="datalist-item">
      <dt>Country</dt>
      <dd>{{ details.bachelor.country | titlecase}}</dd>
    </div>
    <div class="datalist-item">
      <dt>Passport</dt>
      <dd>
        <a [href]="details.bachelor.bachelorPassportPhotograph" target="_blank">
          <img [src]="details.bachelor.bachelorPassportPhotograph" alt="Groom Passport"
               style="max-width: 200px; border-radius: 4px;" />
        </a>
      </dd>
    </div>
    <div class="datalist-item">
      <dt>Birth Certificate</dt>
      <dd><a [href]="details.bachelor.bachelorBirthCertificate" target="_blank">View</a></dd>
    </div>
    <div class="datalist-item">
      <dt>Indigene Certificate</dt>
      <dd><a [href]="details.bachelor.bachelorIndigeneCertificate" target="_blank">View</a></dd>
    </div>
    <div class="datalist-item">
      <dt>Declaration of Age</dt>
      <dd><a [href]="details.bachelor.bachelorDeclarationOfAge" target="_blank">View</a></dd>
    </div>
    <div class="datalist-item">
      <dt>Signature</dt>
      <dd>
        <a [href]="details.bachelor.signature" target="_blank">
          <img [src]="details.bachelor.signature" alt="Groom Signature"
               style="max-width: 200px; border-radius: 4px;" />
        </a>
      </dd>
    </div>

    <!-- Bride Details -->
    <h5 class="mt-3">BRIDE DETAILS</h5>
    <div class="datalist-item">
      <dt>Full Name</dt>
      <dd>{{ details.spinster.firstName }} {{ details.spinster.lastName }}</dd>
    </div>
    <div class="datalist-item">
      <dt>Date of Birth</dt>
      <dd>{{ details.spinster.dob }}</dd>
    </div>
    <div class="datalist-item">
      <dt>Phone</dt>
      <dd>{{ details.spinster.phoneNumber }}</dd>
    </div>
    <div class="datalist-item">
      <dt>Address</dt>
      <dd>{{ details.spinster.address }}</dd>
    </div>
    <div class="datalist-item">
      <dt>State / LGA</dt>
      <dd>{{ details.spinster.state }} / {{ details.spinster.lga }}</dd>
    </div>
    <div class="datalist-item">
      <dt>Country</dt>
      <dd>{{ details.spinster.country | titlecase}}</dd>
    </div>
    <div class="datalist-item">
      <dt>Passport</dt>
      <dd>
        <a [href]="details.spinster.spinsterPassportPhotograph" target="_blank">
          <img [src]="details.spinster.spinsterPassportPhotograph" alt="Bride Passport"
               style="max-width: 200px; border-radius: 4px;" />
        </a>
      </dd>
    </div>
    <div class="datalist-item">
      <dt>Birth Certificate</dt>
      <dd><a [href]="details.spinster.spinsterBirthCertificate" target="_blank">View</a></dd>
    </div>
    <div class="datalist-item">
      <dt>Indigene Certificate</dt>
      <dd><a [href]="details.spinster.spinsterIndigeneCertificate" target="_blank">View</a></dd>
    </div>
    <div class="datalist-item">
      <dt>Declaration of Age</dt>
      <dd><a [href]="details.spinster.spinsterDeclarationOfAge" target="_blank">View</a></dd>
    </div>
    <div class="datalist-item">
      <dt>Signature</dt>
      <dd>
        <a [href]="details.spinster.signature" target="_blank">
          <img [src]="details.spinster.signature" alt="Bride Signature"
               style="max-width: 200px; border-radius: 4px;" />
        </a>
      </dd>
    </div>

    <!-- Other Info -->
    <div class="datalist-item">
      <dt>Oath Certificate</dt>
      <dd>
        <a [href]="details.oathCertificate" target="_blank">
          <img [src]="details.oathCertificate" alt="Oath Certificate"
               style="max-width: 200px; border-radius: 4px;" />
        </a>
      </dd>
    </div>

    <div class="datalist-item">
      <dt>Created By</dt>
      <dd>{{ details.createdBy }}</dd>
    </div>

    <div class="datalist-item">
      <dt>Date Created</dt>
      <dd>{{ details.createdAt }}</dd>
    </div>

  </dl>
</div>






        <!-- BIRTH_REGISTRATION -->
        <div *ngIf="qrCodeType.toUpperCase() == 'BIRTH_REGISTRATION'" class="wrapper">
            <h4 class="title mb-3">BIRTH REGISTRATION DETAILS</h4>
            <dl class="datalist">
                <div class="datalist-item">
                    <dt>Full Name</dt>
                    <dd>{{ details.displayName }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Application ID</dt>
                    <dd>{{ details.applicationId }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Date of Birth</dt>
                    <dd>{{ details.dob }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Time of Birth</dt>
                    <dd>{{ details.timeOfBirth }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Place of Birth</dt>
                    <dd>{{ details.placeOfBirth }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Gender</dt>
                    <dd>{{ details.gender }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Blood Group</dt>
                    <dd>{{ details.bloodGroup }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Genotype</dt>
                    <dd>{{ details.genoType }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Weight at Birth (kg)</dt>
                    <dd>{{ details.weight }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Order of Birth</dt>
                    <dd>{{ details.orderOfBirth }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Type of Delivery</dt>
                    <dd>{{ details.typeOfDelivery }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Mark at Birth</dt>
                    <dd>{{ details.markAtBirth }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Religion</dt>
                    <dd>{{ details.religion }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Approval Status</dt>
                    <dd [ngClass]="'status-text-' + (details.approvalStatus | lowercase)">{{ details.approvalStatus }}
                    </dd>
                </div>
                <div class="datalist-item">
                    <dt>Payment Status</dt>
                    <dd [ngClass]="'status-text-' + (details.paymentStatus | lowercase)">{{ details.paymentStatus }}
                    </dd>
                </div>
                <div class="datalist-item">
                    <dt>Amount</dt>
                    <dd>{{ details.amount | nairaCurrency }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Registered By</dt>
                    <dd>{{ details.createdBy }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Registration Date</dt>
                    <dd>{{ details.createdAt }}</dd>
                </div>
            </dl>
            <h5 class="mt-4">Parents Information</h5>
            <dl class="datalist" *ngFor="let parent of details.parents">
                <div class="datalist-item">
                    <dt>Parent Type</dt>
                    <dd>{{ parent.parentType }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Full Name</dt>
                    <dd>{{ parent.firstName }} {{ parent.lastName }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Phone Number</dt>
                    <dd>{{ parent.phoneNumber }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Address</dt>
                    <dd>{{ parent.address }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Occupation</dt>
                    <dd>{{ parent.occupation }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Marital Status</dt>
                    <dd>{{ parent.maritalStatus }}</dd>
                </div>
            </dl>
        </div>

        <!-- Death Reg -->
        <div *ngIf="qrCodeType.toUpperCase() === 'DEATH_REGISTRATION'" class="wrapper">
            <h4 class="title mb-3">DEATH REGISTRATION DETAILS</h4>
            <dl class="datalist">
                <div class="datalist-item">
                    <dt>Application ID</dt>
                    <dd>{{ details.applicationId }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Full Name</dt>
                    <dd>{{ details.firstName }} {{ details.lastName }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Place of Birth</dt>
                    <dd>{{ details.placeOfBirth }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Date of Death</dt>
                    <dd>{{ details.dod }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Type of Death</dt>
                    <dd>{{ details.typeOfDeath }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Address</dt>
                    <dd>{{ details.address }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Amount</dt>
                    <dd>{{ details.amount | nairaCurrency }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Proof of Death</dt>
                    <dd>
                        <a [href]="details.proofOfDeath" target="_blank">
                            <img [src]="details.proofOfDeath" alt="Proof of Death"
                                style="max-width: 200px; border-radius: 4px;" />
                        </a>
                    </dd>
                </div>

                <div class="datalist-item">
                    <dt>Means of Identification</dt>
                    <dd>
                        <a [href]="details.meansOfIdentification" target="_blank">
                            <img [src]="details.meansOfIdentification" alt="ID"
                                style="max-width: 200px; border-radius: 4px;" />
                        </a>
                    </dd>
                </div>

                <div class="datalist-item">
                    <dt>Approval Status</dt>
                    <dd [ngClass]="'status-text-' + (details.approvalStatus | lowercase)">
                        {{ details.approvalStatus }}
                    </dd>
                </div>

                <div class="datalist-item">
                    <dt>Payment Status</dt>
                    <dd [ngClass]="'status-text-' + (details.paymentStatus | lowercase)">
                        {{ details.paymentStatus }}
                    </dd>
                </div>

                <div class="datalist-item">
                    <dt>Status</dt>
                    <dd [ngClass]="'status-text-' + (details.status | lowercase)">
                        {{ details.status }}
                    </dd>
                </div>

                <div class="datalist-item">
                    <dt>Created By</dt>
                    <dd>{{ details.createdBy }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Date Created</dt>
                    <dd>{{ details.dateCreated }}</dd>
                </div>


            </dl>
        </div>


        <!-- REVALIDATION -->
        <div *ngIf="qrCodeType.toUpperCase() == 'REVALIDATION'" class="wrapper">
            <h4 class="title mb-3">REVALIDATION DETAILS</h4>
            <dl class="datalist">
                <div class="datalist-item">
                    <dt>Application ID</dt>
                    <dd>{{ details.applicationId }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Name</dt>
                    <dd>{{ details.name }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Market</dt>
                    <dd>{{ details.market }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Market Line</dt>
                    <dd>{{ details.marketLine }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Shop No.</dt>
                    <dd>{{ details.shop }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Occupancy</dt>
                    <dd>{{ details.occupancy }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Ownership Type</dt>
                    <dd>{{ details.type }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Individually Owned</dt>
                    <dd>{{ details.individuallyowned }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Rented</dt>
                    <dd>{{ details.rented }}</dd>
                </div>
                <div class="datalist-item" *ngIf="details.rentamount">
                    <dt>Rent Amount</dt>
                    <dd>{{ details.rentamount | nairaCurrency }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Owner ASIN</dt>
                    <dd>{{ details.ownerasin }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Turnover</dt>
                    <dd>{{ details.turnover | nairaCurrency }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Period</dt>
                    <dd>{{ details.period }}</dd>
                </div>
                <div class="datalist-item" *ngIf="details.cost">
                    <dt>Cost</dt>
                    <dd>{{ details.cost | nairaCurrency }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Business Type</dt>
                    <dd>{{ details.business }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Nature of Business</dt>
                    <dd>{{ details.NatureOfBusiness }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Staff Count</dt>
                    <dd>{{ details.staff }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>MDA</dt>
                    <dd>{{ details.mda }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Classification</dt>
                    <dd>{{ details.classification }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Status</dt>
                    <dd [ngClass]="'status-text-' + (details.status | lowercase)">
                        {{ details.status }}
                    </dd>
                </div>
            </dl>
        </div>
        <!-- STREET NAMING -->
        <div *ngIf="qrCodeType.toUpperCase() === 'STREET_NAMING'" class="wrapper">
            <h4 class="title mb-3">STREET NAMING APPLICATION DETAILS</h4>
            <dl class="datalist">
                <div class="datalist-item">
                    <dt>Application Ref</dt>
                    <dd>{{ details.applicationRef }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Name</dt>
                    <dd>{{ details.displayName }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Phone Number</dt>
                    <dd>{{ details.phoneNumber }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Street Address</dt>
                    <dd>{{ details.address }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Street Name</dt>
                    <dd>{{ details.streetName }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Street Type</dt>
                    <dd>{{ details.streetType }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Amount</dt>
                    <dd>{{ details.amount | nairaCurrency }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Approval Status</dt>
                    <dd [ngClass]="'status-text-' + (details.approvalStatus | lowercase)">
                        {{ details.approvalStatus }}
                    </dd>
                </div>

                <div class="datalist-item">
                    <dt>Payment Status</dt>
                    <dd [ngClass]="'status-text-' + (details.paymentStatus | lowercase)">
                        {{ details.paymentStatus }}
                    </dd>
                </div>

                <div class="datalist-item">
                    <dt>Created By</dt>
                    <dd>{{ details.createdBy }}</dd>
                </div>

                <div class="datalist-item">
                    <dt>Created Date</dt>
                    <dd>{{ details.createdAt }}</dd>
                </div>
            </dl>
        </div>

        <!-- PAYMENT -->
        <div *ngIf="qrCodeType.toUpperCase() == 'PAYMENT'" class="wrapper">
            <h4 class="title mb-3">PAYMENT DETAILS</h4>
            <dl class="datalist">
                <div class="datalist-item">
                    <dt>Taxpayer Name</dt>
                    <dd>{{ details.displayName }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Filing Date</dt>
                    <dd>{{ details.filingDate }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Assessment Date</dt>
                    <dd>{{ details.assessmentDate }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Filing Year</dt>
                    <dd>{{ details.filingYear }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Assessment Year</dt>
                    <dd>{{ details.assessmentYear }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Gross Income</dt>
                    <dd>{{ details.grossIncome | nairaCurrency }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>ASIN</dt>
                    <dd>{{ details.asin }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Assessment ID</dt>
                    <dd>{{ details.assessmentId }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Approval Status</dt>
                    <dd [ngClass]="'status-text-' + (details.approvalStatus | lowercase)">{{ details.approvalStatus }}
                    </dd>
                </div>
                <div class="datalist-item">
                    <dt>Payment Status</dt>
                    <dd [ngClass]="'status-text-' + (details.paymentStatus | lowercase)">{{ details.paymentStatus }}
                    </dd>
                </div>
                <div class="datalist-item">
                    <dt>Assessed By</dt>
                    <dd>{{ details.assessedBy }}</dd>
                </div>
                <div class="datalist-item">
                    <dt>Phone Number</dt>
                    <dd>{{ details.phoneNumber }}</dd>
                </div>
            </dl>
        </div>
        }
        @else{
        <div class="d-flex flex-column gap-3 align-items-center">
            <p class="text-danger">Sorry, {{qrCodeType.toUpperCase() | removeUnderscore | lowercase }} application with
                ID:
                {{applicationId}} not found</p>
            <span style="cursor: pointer; color: #1976d2; text-decoration: underline; font-weight: 500;"
                (click)="goBack()">
                ← Back
            </span>
        </div>
        }
        }
        @else {
        <p>Loading details... Please wait.</p>
        }}
        @else {
        <div class="d-flex flex-column align-items-center">
            <p class="text-danger">Details could not be loaded. Check your connection and try again.</p>
            <button class="custom-btn-primary mt-2" (click)="loadData()">
                <i role="button" class="material-icons">refresh</i>
                <span>Reload</span>
            </button>
        </div>
        }
    </div>
</div>